import { atom } from "recoil";

export const addCodeAtom = atom({
  key: "addCodeAtom",
  default: false,
});
